import { makeStyles, Toolbar } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Dialog from "@material-ui/core/Dialog";
import React, { useState } from "react";
import { toAbsoluteUrl } from "../../../../../../../Utils/_helpers";
import ConfigurationToastMessage from "../../Util/ConfigurationToastMessage";
import RecordedUploadSound from "./RecordedUploadSound";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "white",
    boxShadow: "none",
  },

  paper: {
    width: "25%",
    maxWidth: "none",
    display: "flex",
    maxHeight: "100%",
    height: "100%",
    margin: 0,
    boxShadow: "0 2px 18px 0 rgba(0, 0, 0, 0.13)",
    border: "solid 1px rgba(210, 201, 197, 0.3)",
    backgroundColor: "white",
    padding: "25px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      padding: "17px",
      maxHeight: "90%",
      height: "auto",
    },
  },
  scrollPaper: {
    alignItems: "baseline",
    width: "100%",
    maxWidth: "none",
    justifyContent: "end",
    [theme.breakpoints.down("md")]: {
      alignItems: "center",
    },
  },
}));

const EditUploadedSound = ({
  openUploadSoundEditDialog,
  handleCloseEditUploadSound,
  sound,
}) => {
  const classes = useStyles();

  const { soundlibobj } = sound;

  const [toastInfo, setToastInfo] = useState({
    open: false,
    severity: "info",
    snackbarMessage: "",
  });

  const setToastValue = (open, msg, status) => {
    setToastInfo((prevState) => ({
      ...prevState,
      open: open,
      snackbarMessage: msg,
      severity: status,
    }));
  };

  const handleCloseSnackbar = (val) => {
    setToastInfo((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  return (
    <div>
      <ConfigurationToastMessage
        severity={toastInfo.severity}
        snackbarMessage={toastInfo.snackbarMessage}
        open={toastInfo.open}
        handleCloseSnackbar={handleCloseSnackbar}
      />
      <Dialog
        disableBackdropClick
        classes={{
          paper: classes.paper,
          scrollPaper: classes.scrollPaper,
        }}
        style={{ zIndex: "1201" }}
        open={openUploadSoundEditDialog}
        onClose={handleCloseEditUploadSound}>
        <div className="row">
          <div className="col-lg-12">
            <AppBar className={classes.appBar}>
              <Toolbar className="d-flex justify-content-between px-3">
                <div className="secondary-header d-flex align-items-center">
                  <img
                    className=""
                    src={`${toAbsoluteUrl("/media/sr/icons/audio-track.svg")}`}
                    alt="clock"
                    style={{
                      width: "32px",
                      height: "32px",
                      marginRight: "14px",
                    }}
                  />
                  <div className="d-flex flex-column">
                    <span className="mb-1 pt-3">
                      {soundlibobj && soundlibobj.soundname}
                    </span>
                  </div>
                </div>
                <img
                  alt="close"
                  src={toAbsoluteUrl("/media/sr/icons/close.svg")}
                  className="next-arrow-icon"
                  onClick={handleCloseEditUploadSound}
                  style={{ cursor: "pointer", width: "20px", height: "20px" }}
                />
              </Toolbar>
            </AppBar>
            <RecordedUploadSound
              handleCloseUploadSounds={handleCloseEditUploadSound}
              editSound={true}
              soundObj={sound}
              setToastValue={setToastValue}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default EditUploadedSound;
